<footer>
  <div class="main-column text-dark px-0">
    <div class="font-bold text-2xl sm:text-3xl md:text-4xl pt-3 md:pt-6">
      Seattle’s party radio
    </div>
    <div class="sm:flex mt-4 pb-4">
      <div class="basis-1/2">
        <div class="logo">
          <a href="https://dance895.org" target="_blank">
            <img src="/assets/dance895-footer.webp" alt="Dance C89.5 Logo">
          </a>
        </div>
      </div>
      <div class="mt-3 sm:mt-0">
        <div class="font-semibold text-lg">Studio line</div>
        <div>
          call or text | <span class="text-lg font-semibold">206.252.8989</span>
        </div>
      </div>
    </div>
  </div>
  <div class="bg-gray-900 text-white text-sm py-2 pl-2 sm:py-4">
    <div class="main-column">
      &copy; KNHC Public Radio Association {{ copyrightYear }}
    </div>
  </div>
</footer>
